import { Component, OnInit, Inject } from '@angular/core';
import { SnackbarService } from '..';
import { Constants, ProductService } from '../../../core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  standalone: false,
  selector: 'app-massive-product-cancellation-dialog',
  templateUrl: './massive-product-cancellation-dialog.component.html'
})
export class MassiveProductCancellationDialogComponent implements OnInit {
  dispatchItemList: any = [];
  constructor(
    public dialogRef: MatDialogRef<MassiveProductCancellationDialogComponent>,
    public snackbarService: SnackbarService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private productService: ProductService
  ) { 
    const listMotive = Constants.SaleNote.REASON_CANCELLATION.getProps();
    this.dispatchItemList = this.data.map((item: any) => {
      item.reasonCancellation = listMotive[0].text
      item.listMotive = listMotive;
      item.availableItems = item.dispatchItems.pendingAmount // eliminar propiedad luego de validar correctamente las cantidades
      item.canceledItems = item.availableItems; // ver el calculo correcto de calculo de cantidad disponible
      item.canceled = false;
      item.measurable = item.dispatchItems.measurable;
      item.conversionFactor = item.dispatchItems.conversionFactor;
      return item;
    });
  }

  ngOnInit() {
  }

  updateQuantityCancellation(event) {
    const parseQuantity = this.productService.quantityRoundDecimal(this.dispatchItemList[event.index], Number(event.value));
    event.value = parseQuantity;
    const canceledItems: number = parseQuantity;
    const isDecimal = this.dispatchItemList[event.index].measurable ? 0 : 1;
    if (canceledItems >= isDecimal && canceledItems <= Number(event.data.availableItems)) {
      this.dispatchItemList[event.index].canceledItems = canceledItems;
    } else {
      this.dispatchItemList[event.index].canceledItems = 0;
    }
    this.dispatchItemList = JSON.parse(JSON.stringify(this.dispatchItemList))
  }

  changeSelectReason(event) {
    this.dispatchItemList[event.indice].reasonCancellation = event.selectChange.value;
  }

  onClosePartialCancellation() {
    // this.dialogRef.close(this.cancellationResult);
    this.dialogRef.close();
  }

  onSubmitPartialCancellation(){
    this.dialogRef.close(this.dispatchItemList);
  }

}
